import styled from '@emotion/styled';

import { useAppSelector } from '../../../../../shared/store';

import COLOR from '../../../../../shared/constant/colorset';
import { Grade } from '../../../../../shared/enums';
import gradeTextStyle from '../../../../../../constant/gradeTextStyle';

import { addComma } from '../../../../../shared/services';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 14px;
`;

const DiscountByUser = styled.span<{ grade: Grade; }>`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.5px;
  ${({ grade }) => gradeTextStyle[grade]}

  &:after {
    content: "";
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 6px 0 7px;
    background-color: ${COLOR.lightGray};
    vertical-align: -2px;
  }
`;

const Text = styled.span`
  color: ${COLOR.kurlyGray800};
  letter-spacing: -0.5px;

  strong {
    font-weight: 500;
  }
`;

const LoginNotiText = styled.div`
  font-size: 14px;
  color: ${COLOR.kurlyPurple};
  line-height: 19px;
  height: 19px;
  letter-spacing: -0.5px;
  margin-top: 14px;
`;

interface Props {
  loggedIn: boolean;
  isExpectedPoint: boolean;
  expectedPointRatio: number;
  expectedPoint: number;
  isDiscountProduct: boolean;
}

export default function SalesGuide({
  loggedIn,
  isExpectedPoint,
  expectedPointRatio,
  expectedPoint,
  isDiscountProduct,
}: Props) {
  const { userInfo } = useAppSelector(({ auth }) => auth);

  if (!loggedIn) {
    const benefitText = isDiscountProduct ? '할인 및 적립 혜택' : '적립 혜택';

    return (
      <LoginNotiText>
        로그인 후, {benefitText}이 제공됩니다.
      </LoginNotiText>
    );
  }

  if (!isExpectedPoint) {
    return <LoginNotiText>적립 제외 상품입니다.</LoginNotiText>;
  }

  return (
    <Container>
      {userInfo && (
        <DiscountByUser grade={userInfo.grade}>
          {userInfo.grade}{' '}{expectedPointRatio}%
        </DiscountByUser>
      )}
      <Text>
        개당{' '}
        <strong>{addComma(expectedPoint)}원 적립</strong>
      </Text>
    </Container>
  );
}
